export const environment = {
    ebizRootURL: 'https://epaproject1apps.epa.ohio.gov',
    swimsMicroserviceURL: 'https://api-swims.project1.epa.ohio.gov/swims',
    clientID : '9f92644c-2132-44b6-9d26-5d8c8c247aa3',
    redirectURI: 'https://swims.project1.epa.ohio.gov/',  
    envName: 'project1'
};
